"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetModel = exports.widgetDefaultProps = exports.widgetPropType = exports.getImagesForWidget = exports.getMarkdownStringsForWidget = exports.getStringsForWidget = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _page = require("./page");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Get all text strings as an object by their dev ids
 * @param  {Object} widget Custom Widget Contentful object
 * @return {Object of strings} only the strings from the contentful object
 */
var getStringsForWidget = function getStringsForWidget() {
  var widget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _lodash["default"].reduce(widget.textStrings, function (all, string) {
    if ((0, _page.getContentType)(string) === 'basicTextString') {
      all[_lodash["default"].get(string.fields, 'id')] = _lodash["default"].get(string.fields, 'text'); // eslint-disable-line no-param-reassign
    }

    return all;
  }, {});
};
/**
 * Get all markdown strings object by their dev ids
 * @param  {Object} widget Custom Widget Contentful object
 * @return {Object of strings} only the markdown sections from the contentful object
 */


exports.getStringsForWidget = getStringsForWidget;

var getMarkdownStringsForWidget = function getMarkdownStringsForWidget() {
  var widget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _lodash["default"].reduce(widget.textStrings, function (all, string) {
    if ((0, _page.getContentType)(string) === 'textString') {
      all[_lodash["default"].get(string.fields, 'id')] = _lodash["default"].get(string.fields, 'text'); // eslint-disable-line no-param-reassign
    }

    return all;
  }, {});
};
/**
 * Get all images strings object by their internal content id
 * @param  {Object} widget Custom Widget Contentful object
 * @return {Object{
 *    src: url
 *    alt: decription of the image
 *    title: title of the image
 * }} all images from the contentful object
 */


exports.getMarkdownStringsForWidget = getMarkdownStringsForWidget;

var getImagesForWidget = function getImagesForWidget() {
  var widget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _lodash["default"].reduce(widget.images, function (all, image) {
    // eslint-disable-next-line no-param-reassign
    all[_lodash["default"].get(image, 'sys.id')] = {
      src: _lodash["default"].get(image, 'fields.file.url'),
      alt: _lodash["default"].get(image, 'fields.description'),
      title: _lodash["default"].get(image, 'fields.title')
    };
    return all;
  }, {});
};

exports.getImagesForWidget = getImagesForWidget;
var widgetPropType = {
  textStrings: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    fields: _propTypes["default"].shape({
      id: _propTypes["default"].string,
      text: _propTypes["default"].string
    })
  })),
  sections: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    fields: _propTypes["default"].shape({
      title: _propTypes["default"].string,
      text: _propTypes["default"].string
    })
  }))
};
exports.widgetPropType = widgetPropType;
var widgetDefaultProps = {
  textStrings: [],
  sections: []
};
/**
 * Widget model to make working with raw widget data simpleStrings
 *
 * Wrap any raw widget data in this before sharing it around so we
 * are not tempted to access it directly
 */

exports.widgetDefaultProps = widgetDefaultProps;

var WidgetModel = /*#__PURE__*/function () {
  /**
   * @param {object} widgetData  Custom Widget Contentful object
   */
  function WidgetModel(widgetData) {
    _classCallCheck(this, WidgetModel);

    this.widgetData = widgetData;
  }
  /**
   * @return  {Object of strings} only the strings from the contentful object
   */


  _createClass(WidgetModel, [{
    key: "textStrings",
    get: function get() {
      if (!this.textStringsInternal) {
        this.textStringsInternal = getStringsForWidget(this.widgetData.fields);
      }

      return this.textStringsInternal;
    }
    /**
     * @return {Object of strings} only the markdown sections from the contentful object
     */

  }, {
    key: "markdownStrings",
    get: function get() {
      if (!this.markdownStringsInternal) {
        this.markdownStringsInternal = getMarkdownStringsForWidget(this.widgetData.fields);
      }

      return this.markdownStringsInternal;
    }
    /**
     * @return {Object{
     *    src: url
     *    alt: decription of the image
     *    title: title of the image
     * }} all images from the contentful object
     */

  }, {
    key: "images",
    get: function get() {
      if (!this.imagesInternal) {
        this.imagesInternal = getImagesForWidget(this.widgetData.fields);
      }

      return this.imagesInternal;
    }
  }]);

  return WidgetModel;
}();

exports.WidgetModel = WidgetModel;